import * as React from 'react';

import { Container, Tabs, ButtonTab } from './NavigationHeader.styles';

interface INavigationHeader {
  tabs: string[];
  disabledTabs?: string[];
  selectedTab: string;
  secondaryContent?: React.ReactNode;
  onTabClick: (tab: string) => void;
}

export const NavigationHeader: React.FC<INavigationHeader> = ({
  tabs,
  disabledTabs,
  selectedTab,
  secondaryContent,
  onTabClick,
}) => {
  return (
    <Container>
      <Tabs>
        {tabs.map((tab) => (
          <ButtonTab
            key={tab}
            disabled={disabledTabs?.includes(tab)}
            isSelected={tab === selectedTab}
            onClick={() => onTabClick(tab)}
          >
            {tab}
          </ButtonTab>
        ))}
      </Tabs>
      {secondaryContent}
    </Container>
  );
};
